import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, useLocation } from 'react-router-dom';
import "./styles/tailwind.css";
import App from './App';



const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return children || null;
};

ReactDOM.render(
  <BrowserRouter>
  <React.StrictMode>
  <ScrollToTop>
    <App />
  </ScrollToTop>
  </React.StrictMode>
  </BrowserRouter>,
  document.querySelector('#root')
);